import { useState, useEffect } from "react";
import Modal from "@src/common/Modal";
import { getAgentPoints } from '@src/store/slices/insuranceId';
import * as HELPER from "@src/config/helper";
import { AGENT_COMMISSION_STATUS } from "@src/config/id/constant";
import { cancelRequest, saveAgentDetails, agentPointStatus } from '@src/store/slices/insuranceId';
import { getPointValues } from "@src/pages/insurance/create/functions/common.fn";
import { toast } from "react-toastify";
import { useDispatch} from 'react-redux'
import { getInsuranceListID } from "@store/slices/insurance";
import { useLanguage } from "@src/context/LanguageContext";

const STEP = 0.5;

interface Props {
  type?: string;
  show?: any;
  handleClose?: any;
  leadDetail?: any;
  setLeadDetails?: any;
  setShowApprovalPopup?: any;
  setShowAgentPointPopup?: any;
  statusType?: any;
  setTrigger?: any;
  callFrom?: any;
  selectedFilters?:any;
   setInsuranceListData?: React.Dispatch<React.SetStateAction<any[]>>;
   setLoading?:React.Dispatch<React.SetStateAction<boolean>>;
}


export default function ProfitChangeModal({ show,
  handleClose,
  leadDetail,
  type, statusType, setTrigger, callFrom, selectedFilters,setInsuranceListData, setLoading
}: Props) {
  const [activeTab, setActiveTab] = useState("points");
  const [remarks, setRemarks] = useState("");
  const [commissionData, setCommissionData] = useState(leadDetail);
  const [agentPercent, setAgentPercent] = useState(0);
  const [customerPercent, setCustomerPercent] = useState(0);
  const [value, setValue] = useState(0);
  const [isValueInputFocused, setIsValueInputFocused] = useState(false);
  const [valueInputError, setValueInputError] = useState("");
  const [screen, setScreen] = useState<"profit" | "approval" | "">(type as any);
  const [pointScreen, setPointScreen] = useState<"pointsApproval" | "suggest_new_point">("pointsApproval");
  const [previewAgentValue, setPreviewAgentValue] = useState<number | null>(null);
  const [baseValues, setBaseValues] = useState<any>(null);
  const [customerDiscountAlertPopUp, setCustomerDiscountAlertPopUp] = useState(false);

  const [colorMap, setColorMap] = useState({
  agent_commission: "black",
  customer_discount: "black",
  agent_points: "black",
  oto_gross_profit: "black",
});
 const dispatch: any = useDispatch();
 const {translations} = useLanguage();
 const discountExceedText = activeTab === "points" ? "": translations?.AGENT_COMMISSION?.CUST_PT_EXCEED;
  // set deafult agent and customer %
  useEffect(() => {
    if (screen === "profit" || screen === "approval") {
      if (show && leadDetail) {
        const agent_per = leadDetail?.agent_points.percentage;
        const cust_per = leadDetail?.customer_discount.percentage;

        setAgentPercent(agent_per);
        setCustomerPercent(cust_per);
        setCommissionData(leadDetail);

        setBaseValues(leadDetail);
        setColorMap({
          agent_commission: "black",
          customer_discount: "black",
          agent_points: "black",
          oto_gross_profit: "black",
        });
      }
    }
  }, [show, leadDetail]);


  // set default customer agent value
  useEffect(() => {
    if (!show) return;
    setValueInputError("");

    if (activeTab === "points") {
      setValue(agentPercent ?? 0);
    } else {
      setValue(customerPercent ?? 0);
    }
  }, [activeTab, show, agentPercent, customerPercent]);


  // when value change api will give live calculation
  const updateValue = (newVal: number) => {
    let newAgent = agentPercent;
    let newCustomer = customerPercent;

    if (activeTab === "points") {
      newAgent = newVal;
      setAgentPercent(newVal);
    } else {
      newCustomer = newVal;
      setCustomerPercent(newVal);
    }

    setValue(newVal);

    if (!(type === "pointsApproval" && pointScreen === "suggest_new_point")) {
      hitPreviewApi(newAgent, newCustomer);
    }
    if (pointScreen === "suggest_new_point") {
      hitPreviewApi(newVal, leadDetail.customer_discount_per);
    }
  };


  const hitPreviewApi = async (agent: number, customer: number) => {
    const payload = {
      lead_id: +leadDetail?.leadId || +leadDetail?.application_id,
      customer_point_per: customer || 0,
      agent_point_per: agent || 0,
    };

    const res: any = await getAgentPoints(payload);
    const newData = res.data;
    setPreviewAgentValue(newData?.agent_points?.value || 0);
    setCommissionData(newData);
    if(screen === "profit" || screen === "approval"){

      if (!baseValues) return;
    
        const getColor = (newVal: number, oldVal: number) => {
    if (newVal > oldVal) return "green";
    if (newVal < oldVal) return "red";
    return "black";
  };

  setColorMap({
    agent_commission: getColor(
      newData?.agent_commission?.value,
      baseValues?.agent_commission?.value
    ),
    customer_discount: getColor(
      newData?.customer_discount?.value,
      baseValues?.customer_discount?.value
    ),
    agent_points: getColor(
      newData?.agent_points?.value,
      baseValues?.agent_points?.value
    ),
    oto_gross_profit: getColor(
      newData?.oto_gross_profit?.percentage,
      baseValues?.oto_gross_profit?.percentage
    ),
  });
    }

  };


  const handleIncrease = () => {
    if ((type === "profit" || type === "profit") && isCounterDisabled) return;

    const maxLimit = getMaxLimit();
    const next = HELPER.roundPercent(value + STEP);
    if (next > maxLimit) return;
    updateValue(next);
  };

  const handleDecrease = () => {
    if ((type === "profit" || type === "profit") && isCounterDisabled) return;

    const next = HELPER.roundPercent(value - STEP);
    if (next < 0) return;
    updateValue(next);
  };

  const handleReset = () => {
    const agent_per = leadDetail.agent_points.percentage;
    const cust_per = leadDetail.customer_discount.percentage;

    setAgentPercent(agent_per);
    setCustomerPercent(cust_per);
    setCommissionData(leadDetail);

    setValue(activeTab === "points" ? agent_per : cust_per);

    //hitPreviewApi(agent_per, cust_per);
  setColorMap({
    agent_commission: "black",
    customer_discount: "black",
    agent_points: "black",
    oto_gross_profit: "black",
  });

  };


  const SaveDetails = async () => {
    const gp = commissionData?.oto_gross_profit?.percentage;
    // for customer screen
    if (activeTab === "discount") {
      setCustomerDiscountAlertPopUp(true);
      setScreen("");
      return;
    }
    // for agent case
    if (gp < 3) {
      // approval required
      setScreen("approval");
    }
    else {
      finalSave(false);
    }
  }

  // when BM edit gross profit is less then 3% or above then save api will run 
  const finalSave = async (isApproval: boolean) => {
    try{
   setLoading?.(true);
    const payload: any = {
      can_send_for_approval: isApproval,
      agent_comm: commissionData.agent_commission?.value,
      agent_comm_per: commissionData.agent_commission?.percentage,
      customer_disc: commissionData.customer_discount?.value,
      customer_disc_per: commissionData.customer_discount?.percentage,
      agent_point_value: commissionData.agent_points?.value,
      agent_point_per: commissionData.agent_points?.percentage,
      oto_gross_profit_per: commissionData.oto_gross_profit?.percentage,
      lead_id: leadDetail.leadId,
      old_agent_point: leadDetail.agent_points?.percentage,
      old_agent_value: leadDetail.agent_points?.value,
    }
    if (isApproval) {
      payload.comment = remarks;
    }
    await saveAgentDetails(payload);
    await LeadListing(selectedFilters);
    handleClose();
    
  }catch(err){
    console.error('err==',err)
  }finally{
    setLoading?.(false);
  }
    //setTrigger((prev: number) => prev + 1);

  }


  // VP will cancell request
  const CancelRequest = async (lead_id: any) => {
    try{
      setLoading?.(true);
    let payLoad = {
      status_id: 2,
      lead_id: lead_id
    }
    cancelRequest(payLoad).then(async(res: any) => {
      if (res?.status === 200) {
      await LeadListing(selectedFilters);
        handleClose();
      }
    });
  }catch(err){
    console.error(err)
  }finally{
    setLoading?.(false); 
  }
  }


  const handleApprovalSubmit = () => {
    if (!remarks || !remarks.trim()) {
    toast.error("Please enter apporval remarks");
    return;
  }
    finalSave(true);
  };


  useEffect(() => {
    if (show && type === "pointsApproval") {
      setPointScreen("pointsApproval");
    }
  }, [show, type]);


  // vp will approve or reject it
  const handleSubmitDecision = () => {
    const isApprove = pointScreen === "pointsApproval";

    const payload: any = {
      lead_id: +points?.leadId,
      status: isApprove ? 1 : 2,
    };

    //  reject flow 
    if (!isApprove) {
      payload.old_agent_point = points?.newPercentage;
      payload.agent_point_per = value;
    }

    // same API call
    setLoading?.(true);
    agentPointStatus(payload).then((res:any)=>{
    if(res?.status === 200){
      setInsuranceListData?.((prev: any[] = []) =>
        prev.map((lead: any) =>
          +lead?.leadId === +payload?.lead_id
            ? { ...lead, agent_point_send: false }
            : lead
        )
      );
      if(payload.status === 2){    
        toast.success("Rejected Successfully");
        setLoading?.(false);
      }else{
        toast.success("Approved Successfully");
        setLoading?.(false);
      }   
       handleClose();
    }else{
       handleClose();
       setLoading?.(false);
    } 
    });
    //setTrigger((prev: number) => prev + 1);
   
  };


  const points = getPointValues(leadDetail, callFrom);

  // customer and agent max input limit
  const getMaxLimit = () => {
    if (activeTab === "discount") {
      return leadDetail?.max_discount ?? 0;
    } else {
      return leadDetail?.max_agent_point ?? 0;
    }
  };


  //Agent disabled 
  const canEditAgent = leadDetail?.status < 5 && leadDetail?.sub_status < 8;
  //Customer disabled
  const canEditCustomer = leadDetail?.status < 2 && leadDetail?.sub_status < 3;

  const isCounterDisabled = activeTab === "points" ? !canEditAgent : !canEditCustomer;


  useEffect(() => {
    if (
      type === "pointsApproval" &&
      pointScreen === "suggest_new_point"
    ) {
      setValue(points?.newPercentage || 0);
    }
  }, [type, pointScreen, points?.newPercentage]);

  const LeadListing = async (params: any) => {
    try {
      setLoading?.(true);
      const res = await dispatch(getInsuranceListID(params))
      if (res?.status === 200) {
        setInsuranceListData?.(res?.data?.leads)
      }
    } catch (err) {
      console.error('err')
    } finally {
      setLoading?.(false);
    }

  }

  useEffect(() => {
    if (show) document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    }
  }, [show])

  return (
    <div className={`model-outer upload-error-popup dashboard-filter-popup profit-change-modal ${ (screen === "approval" || type === "Approval Required") ? "required-approved": ""}`}>
      <Modal show={show} handleClose={handleClose}>
        {/* -------- Header -------- */}
          <div className={`pcm-header modal-header ${type === "pointsApproval" ? "suggestion-point-header" : ""}`}>
          <div className="profit-headng-top">        
            <h2>
              {customerDiscountAlertPopUp ? translations?.COMMON_MSG?.DISCARD_CHANGE
              : 
              <>
              {(screen === "profit" || type === "summary" || type === "summary1") && `${leadDetail?.customer_name} Profit Change`}
              {(screen === "approval" || type === "Approval Required") && "Approval Required"
              }
              {type === "pointsApproval" && (pointScreen === "suggest_new_point"? translations?.AGENT_COMMISSION?.SUGGEST_NEW_POINT: translations?.AGENT_COMMISSION?.AGENT_PT_CHANGE_APPROVAL)}    
              {type === "suggest_new_point" && "Suggest New Points"}
              </>         
              }
            </h2>
            {(screen === "approval" || type === "Approval Required") &&
              <span>{translations?.AGENT_COMMISSION?.OTO_PROFIT_EXCEED}  </span>
            }

            {(screen === "profit" || type === "summary" || type === "summary1") && (
              <span className="ktp"> {leadDetail?.ktp_id
                ? `KTP ID ${leadDetail?.ktp_id}`
                : leadDetail?.npwp_no
                  ? `NPWP No ${leadDetail?.npwp_no}`
                  : ''}</span>
            )}
              {screen === "profit" && (
            <span className="reset reset-txt" onClick={handleReset}>
              {translations?.AGENT_COMMISSION?.RESET}
            </span>
          )}
          </div>

        </div>
        <div className="modal-body">
        {/* -------- BODY -------- */}
        {!customerDiscountAlertPopUp && screen === "profit" && (
          <>
            <div className="commissionBox">
              <div className="boxTitle">
                {translations?.AGENT_COMMISSION?.AGENT_COMMMISSION_PT_DETAILS}
              </div>
              <Row
                label= {translations?.AGENT_COMMISSION?.AGENT_COMM}
                //value={(leadDetail?.agent_commission?.value)`$ (leadDetail?.agent_commission.percentage) `}
                value={`Rp ${commissionData?.agent_commission?.value || 0} (${HELPER.roundPercent(commissionData?.agent_commission?.percentage || 0)}%)`}

                 color={colorMap.agent_commission}
              />
              <Row
                label={translations?.AGENT_COMMISSION?.CUST_DISC}
                value={`Rp ${commissionData?.customer_discount?.value || 0} (${HELPER.roundPercent(commissionData?.customer_discount?.percentage || 0)}%)`}
                 color={colorMap.customer_discount}
              />
              <Row label= {translations?.AGENT_COMMISSION?.AGENT_PT}
                value={`Rp ${commissionData?.agent_points?.value || 0} (${HELPER.roundPercent(commissionData?.agent_points?.percentage || 0)}%)`}
              color={colorMap.agent_points}
              />
              <Row label={translations?.AGENT_COMMISSION?.OTO_GROSS_PT} 
                value={`${HELPER.roundPercent(commissionData?.oto_gross_profit?.percentage || 0)} %`}
                color={colorMap.oto_gross_profit}
              />
            </div>

            <h4 className="changeTitle change-agnent-profit-txt"> {translations?.AGENT_COMMISSION?.CHANGE_AGENT_PT}</h4>

            <div className="tabSwitch ">
             <button
                className={
                  activeTab === "points" ? "tabBtn active" : "tabBtn"
                }
                onClick={() => setActiveTab("points")}
              >
                {translations?.AGENT_COMMISSION?.AGENT_PT}
              </button>
              <button
                className={
                  activeTab === "discount" ? "tabBtn active" : "tabBtn"
                }
                onClick={() => setActiveTab("discount")}
              >
                {translations?.AGENT_COMMISSION?.CUST_DISC}
              </button>
              
            </div>

            <div className="counterBox">
              <button className="pillBtn" onClick={handleDecrease} disabled={isCounterDisabled}>−</button>
              <div className="counterValue">
                {/* {value} % */}
                <div className="search-bx">
                  <div className="material" title="Search by anything">
                    <input
                      type="number"
                      className="counterInput"
                      value={isValueInputFocused && value === 0 ? "" : HELPER.roundPercent(value)}
                      min={0}
                      max={getMaxLimit()}
                      step={STEP}
                      disabled={isCounterDisabled}
                      onFocus={() => setIsValueInputFocused(true)}
                      onChange={(e) => {
                        let inputVal = e.target.value;

                        // allow empty for better UX
                        if (inputVal === "") {
                          setValue(0);
                          return;
                        }

                        // max 4 decimals allowed for percentage input
                        if (!HELPER.isValidDecimal(inputVal)) {
                          setValueInputError(translations?.COMMON_MSG?.MAX_4D);
                          return;
                        }
                        setValueInputError("");

                        let num = parseFloat(inputVal);

                        if (isNaN(num)) return;
                        const maxLimit = getMaxLimit();

                        if (num > maxLimit) num = maxLimit;
                        if (num < 0) num = 0;

                        updateValue(HELPER.roundPercent(num));
                      }}
                      onBlur={(e) => {
                        setIsValueInputFocused(false);

                        // ensure value always formatted properly
                        let num = parseFloat(e.target.value);
                        const maxLimit = getMaxLimit();

                        if (isNaN(num)) num = 0;

                        if (num > maxLimit) num = maxLimit;
                        if (num < 0) num = 0;

                        setValueInputError("");
                        // untouched field: keep the full-precision server value, don't re-send a rounded copy
                        if (HELPER.roundPercent(num) === HELPER.roundPercent(value)) return;
                        updateValue(HELPER.roundPercent(num));
                      }}
                    />
                    {valueInputError && <span className="error-txt">{valueInputError}</span>}
                  </div>
                </div>


              </div>
              <button className="pillBtn pill-btn-right" onClick={handleIncrease} disabled={isCounterDisabled}>+</button>
            </div>

            <p className="note">
             {discountExceedText}
            </p>

            <button className="saveBtn" onClick={SaveDetails}> {translations?.AGENT_COMMISSION?.SAVE_DETAILS} </button>
          </>
        )}

        {(screen === "approval" &&
          <>
            {/* -------- Approval UI -------- */}
            

            <textarea
              className="remarksBox"
              placeholder= {`${translations?.AGENT_COMMISSION?.REMARKS} *`}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />

            <button className="saveBtn" onClick={handleApprovalSubmit}> {translations?.AGENT_COMMISSION?.SUBMIT} </button>
          </>
        )}

        {type === "summary" && (
          <>
            <div className="commissionBox">
              <div className="boxTitle">
                {translations?.AGENT_COMMISSION?.AGENT_COMMMISSION_PT_DETAILS}
              </div>

              {/* {leadDetail?.agent_com_point_details?.map((item: any, index: number) => ( */}
              <div>
                <div className = "crossIcon-word">
                <Row
                  label={translations?.AGENT_COMMISSION?.AGENT_PT}
                  value={`${HELPER.addCurrencyFormatting(leadDetail.agent_new_point_value)} (${leadDetail.agent_new_point} %)`}
                  color={
                    leadDetail.agent_new_point_value > leadDetail.old_agent_value
                      ? "green"
                      : leadDetail.agent_new_point_value < leadDetail.old_agent_value
                        ? "red"
                        : "black"
                  }
                />
                {/* <div className="rowItem">
                  <span className="cross-word-line">
                    {`${HELPER.addCurrencyFormatting(leadDetail.old_agent_value)} (${leadDetail.old_agent_point} %)`}
                  </span>
                </div> */}
                 <span className="cross-word-line">
                        {`${HELPER.addCurrencyFormatting(leadDetail.agent_points?.value ?? leadDetail.old_agent_value ?? 0)} (${HELPER.roundPercent(leadDetail.agent_points?.percentage ?? leadDetail.old_agent_point ?? 0)}) %`}
                  </span>
                  </div>
                <Row
                  label={translations?.AGENT_COMMISSION?.OTO_GROSS_PT }
                  value={`${leadDetail.oto_gross_profit} %`}
                  color = "red"
                />
              </div>


            </div>

            {statusType === AGENT_COMMISSION_STATUS.pending && (
              <>
                <div className="approvalNotesBox">
                  <div className="notesTitle">{translations?.AGENT_COMMISSION?.APPROVAL_NOTES}</div>
                  <p>{leadDetail?.comment} </p>
                </div>

                <button className="cancelBtn" onClick={() => { CancelRequest(leadDetail.application_id) }}>{translations?.AGENT_COMMISSION?.CANCEL_REQ_BTN}</button>
              </>
            )
            }
          </>
        )}

        {type === "summary1" && (
          <>
            <div className="commissionBox">
              <div className="boxTitle">
                {translations?.AGENT_COMMISSION?.AGENT_COMMMISSION_PT_DETAILS}
              </div>

              {/* {leadDetail?.map((item: any, index: number) => ( */}
              <div >
                <div className = "crossIcon-word">
                <Row
                  label={translations?.AGENT_COMMISSION?.AGENT_POINT}
                  value={`${HELPER.addCurrencyFormatting(leadDetail.new_agent_points.value)} (${HELPER.roundPercent(leadDetail.new_agent_points.percentage)} %)`}
                  color={
                    +points?.newValue > points?.oldValue
                      ? "green"
                      : points?.newValue < points?.oldValue
                        ? "red"
                        : "black"
                  }
                />
                {/* <div className="rowItem">
                  <span className="cross-word-line">
                    {`${HELPER.addCurrencyFormatting(leadDetail.agent_points?.value)} (${HELPER.roundPercent(leadDetail.agent_points?.percentage)}) %`}
                  </span>
                </div> */}
                <span className="cross-word-line">
                        {`${HELPER.addCurrencyFormatting(leadDetail.agent_points?.value ?? leadDetail.old_agent_value ?? 0)} (${HELPER.roundPercent(leadDetail.agent_points?.percentage ?? leadDetail.old_agent_point ?? 0)}) %`}
                      </span>
                </div>

                <Row
                  label={translations?.AGENT_COMMISSION?.GROSS_PROFIT}
                  value={`${HELPER.roundPercent(leadDetail.oto_gross_profit.percentage)} %`}
                  color= "red" 
                />

              </div>

            </div>

            <div className="approvalNotesBox">
              <div className="notesTitle">{translations?.AGENT_COMMISSION?.APPROVAL_NOTES}</div>
              <p>{leadDetail?.comment} </p>
            </div>
            {/* {statusType === AGENT_COMMISSION_STATUS.pending && ( */}
            <button className="cancelBtn" onClick={() => { CancelRequest(leadDetail.leadId) }}>{translations?.AGENT_COMMISSION?.CANCEL_REQ_BTN}</button>
            {/* )
            } */}
          </>
        )}

        {type === "pointsApproval" && pointScreen === "pointsApproval" && (
          <>
            <div className="commissionBox">
              <div className="boxTitle"> {translations?.AGENT_COMMISSION?.PT_CHANGE_DETAILS}</div>

              <Row label= {translations?.AGENT_COMMISSION?.APPLICATION_ID} value={points?.leadId} />
              <Row label= {translations?.AGENT_COMMISSION?.BM_NAME}  value={leadDetail?.bm_name} />
              <Row label= {translations?.AGENT_COMMISSION?.AGENT_NAME}  value={leadDetail?.agent_name} />
              <Row label= {translations?.AGENT_COMMISSION?.AGENT_ID}  value={leadDetail?.agent_id} />
              <Row label={translations?.AGENT_COMMISSION?.CUSTOMER_NAME}  value={leadDetail?.customer_name} />

              <Row
                label={translations?.AGENT_COMMISSION?.AGENT_OLD_PT}
                value={`${HELPER.addCurrencyFormatting(points.oldValue || "")} (${points.oldPercentage || 0}%)`}
                color = "blue"
              />
              <Row
                label={translations?.AGENT_COMMISSION?.AGENT_NEW_PT}
                value={`${HELPER.addCurrencyFormatting(points.newValue || "")} (${points.newPercentage || 0}%)`}
                color = "blue"
              />
              <Row
                label= {translations?.AGENT_COMMISSION?.OTO_GROSS_PT}
                value={`${points.grossProfit || 0} %`}
                color = "red"
              />
            </div>

            {(statusType === AGENT_COMMISSION_STATUS.pending || callFrom === "LeadList") && (
              <>
                <div className="approvalNotesBox">
                  <div className="notesTitle">{translations?.AGENT_COMMISSION?.APPROVAL_NOTES}</div>
                  <p>
                    {leadDetail?.comment}
                  </p>
                </div>

                <div className="actionBtnRow">
                  <button className="rejectBtn" onClick={() => setPointScreen("suggest_new_point")}>{translations?.AGENT_COMMISSION?.REJECT} </button>
                  <button className="acceptBtn" onClick={handleSubmitDecision}> {translations?.AGENT_COMMISSION?.ACCEPT}</button>
                </div>
              </>)}

          </>
        )}

        {type === "pointsApproval" && pointScreen === "suggest_new_point" && (
          <div className="pointsSuggestBox">
            <p className="oldPoints">
              {translations?.AGENT_COMMISSION?.AGENT_OLD_PT} –&nbsp;&nbsp; 
             
                {`${HELPER.addCurrencyFormatting(points.oldValue || "")} (${points.oldPercentage || 0}%)`}
              
            </p>
            <div className="points-suggestion-outer">
              <div className="pointsPillWrapper">
                <button className="pillBtn" onClick={handleDecrease}>−</button>

                <div className="pointsPill">
                  <div className="pillPercentage">
                    {/* {value}% */}

                    <div className="search-bx">
                      <div className="material" title="Search by anything">
                        <input
                          type="number"
                          className="counterInput"
                          value={isValueInputFocused && value === 0 ? "" : HELPER.roundPercent(value)}
                          min={0}
                          max={leadDetail.max_agent_point}
                          step={STEP}
                          onFocus={() => setIsValueInputFocused(true)}
                          onChange={(e) => {
                            let inputVal = e.target.value;

                            // allow empty for better UX
                            if (inputVal === "") {
                              setValue(0);
                              return;
                            }

                            // max 4 decimals allowed for percentage input
                            if (!HELPER.isValidDecimal(inputVal)) {
                              setValueInputError(translations?.COMMON_MSG?.MAX_4D);
                              return;
                            }
                            setValueInputError("");

                            let num = parseFloat(inputVal);

                            if (isNaN(num)) return;

                            if (num > leadDetail.max_agent_point) num = leadDetail.max_agent_point;
                            if (num < 0) num = 0;

                            updateValue(HELPER.roundPercent(num));
                          }}
                          onBlur={(e) => {
                            setIsValueInputFocused(false);

                            let num = parseFloat(e.target.value);

                            if (isNaN(num)) num = 0;

                            if (num > leadDetail.max_agent_point) num = leadDetail.max_agent_point;
                            if (num < 0) num = 0;

                            setValueInputError("");
                            // untouched field: keep the full-precision server value, don't re-send a rounded copy
                            if (HELPER.roundPercent(num) === HELPER.roundPercent(value)) return;
                            updateValue(HELPER.roundPercent(num));
                          }}

                        />
                        {valueInputError && <span className="error-txt">{valueInputError}</span>}
                      </div>
                    </div>

                  </div>
                
                </div>

                <button className="pillBtn pill-btn-right" onClick={handleIncrease}>+</button>
              </div>
                <div className="pillAmount">
                    {HELPER.addCurrencyFormatting(previewAgentValue !== null ? previewAgentValue : points.newValue)}
                  </div>
             </div>             
            <button className="saveBtn" onClick={handleSubmitDecision}> {translations?.AGENT_COMMISSION?.SEND}</button>
          </div>
        )}

        {/* Customer Discount Alert Confirm Popup */}
          {(customerDiscountAlertPopUp &&
          <>
            {/* -------- Approval UI -------- */}
            <div className="discard-change-txt">
               <span>{translations?.COMMON_MSG?.ARE_SURE}  </span>
              <span>{HELPER.roundPercent(leadDetail?.customer_discount?.percentage ?? 0)}% to {HELPER.roundPercent(value)}%
           </span>
                 <span> {translations?.COMMON_MSG?.AFFECT_COMMSSION} </span>
                 </div>
            <div className="tabSwitch p-lg-t">
            <button className="btn-primary w-100" onClick={() => {
              setCustomerDiscountAlertPopUp(false);
              finalSave(false);
            }}> {translations?.COMMON_MSG?.OKAY } </button>
              <button className="btn-line w-100" onClick={() => {
                setCustomerDiscountAlertPopUp(false);
                setScreen("profit");
              }}> {translations?.COMMON_MSG?.CANCEL } </button>
            </div>
          </>
        )}        
    </div>
      </Modal>
    </div>
  );
}

const Row = ({ label, value, color = "black",subValue }:any) => {
  return (
    <div className="rowItem">
      <span>{label}</span>
      <div className="profit-change-rp-txt">
     <span style={{ color }} className={color === "blue" ? "txt-agnet-value" : ""}>
  {value}
</span>


      </div>
    </div>
  );
};
